
import type { DrawerAPI, DrawerPayload } from './drawerHostBridge'
import { getDrawerHost, whenDrawerHostReady } from './drawerHostBridge'

export const DrawerHost = {
  open(payload: DrawerPayload) {
    getDrawerHost().open(payload)
  },
  close() {
    getDrawerHost().close()
  },
  onReady(cb: (api: DrawerAPI) => void) {
    whenDrawerHostReady(cb)
  }
}

export type { DrawerAPI, DrawerPayload }
